import * as React from "react";
import { useEffect } from "react";
import type { ApplyFiltersToURL } from "../SharedPages/OrganizationPage/ProductsList/ProductsList.util";
import { appendFiltersToUrl } from "../SharedPages/OrganizationPage/ProductsList/ProductsList.util";
import { PortfolioModernView } from "./PortfolioLayouts/PortfolioModernView";
import { useStoreState } from "../../util/util";
import { useAuthContext } from "../../components/Auth";
import { Redirect, useHistory } from "react-router-dom";
import { useRoutePath } from "../../util/Routing";

// Re-export from filterStateManager for backward compatibility
export { groupPortfolioParamsByKey } from "../../util/filterStateManager";

export function applyFiltersToURL({
  active_tag_view,
  q,
  filtersFromUrl,
  params,
}: ApplyFiltersToURL): URLSearchParams {
  if (filtersFromUrl) {
    Object.entries(filtersFromUrl)?.forEach((filterList) => {
      appendFiltersToUrl({
        existingParams: params,
        paramsToAppend: filterList[1],
        key: filterList[0],
      });
    });
  }

  if (active_tag_view) {
    appendFiltersToUrl({
      existingParams: params,
      paramsToAppend: [active_tag_view],
      key: "active_tag_view",
    });
  }

  if (q) {
    appendFiltersToUrl({
      existingParams: params,
      paramsToAppend: [q],
      key: "q",
    });
  }

  return params;
}

export const PublicIndexWrapper = () => {
  const { storefront_metadata } = useStoreState();
  const { roleIsSomeKindOfBuyer } = useAuthContext();
  const history = useHistory();
  const { adminPath, storePath } = useRoutePath();
  const { route_configuration } = storefront_metadata;

  const portfolioRoute = route_configuration.find(
    (route) => route.route === "portfolio"
  );

  useEffect(() => {
    if (roleIsSomeKindOfBuyer) {
      history.push(
        `${adminPath}/pim/products${
          sessionStorage.getItem("products_search") ?? ""
        }`
      );
    }
  }, [roleIsSomeKindOfBuyer, adminPath, history]);

  if (portfolioRoute?.enabled === false) {
    return <Redirect to={`${storePath}/login`} />;
  }

  // Always use the unified portfolio view (formerly "modern" view)
  return <PortfolioModernView isPublic />;
};
